import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import BottomTabNavigation from '../../components/ui/BottomTabNavigation'
import PostDetailsOverlay from '../../components/ui/PostDetailsOverlay'
import FeedHeader from './components/FeedHeader'
import PostCard from './components/PostCard'
import FeedSkeleton from './components/FeedSkeleton'
import { feedService } from '../../services/feedService'
import { useAuth } from '../../contexts/AuthContext'
import { followService } from '../../services/followService'

const mapPost = (post) => ({
  id: post.id,
  userId: post.authorId,
  username: post.author.username,
  userAvatar: post.author.avatarUrl || 'https://via.placeholder.com/120',
  userAvatarAlt: post.author.username,
  timestamp: post.createdAt,
  caption: post.content,
  mediaType: post.mediaUrl ? 'image' : null,
  mediaUrl: post.mediaUrl,
  mediaAlt: post.content,
  likes: post.likeCount,
  isLiked: post.isLiked,
  comments: 0,
  shares: 0,
  hashtags: []
})

const HomeFeed = () => {
  const navigate = useNavigate()
  const { user, loading } = useAuth()
  const [posts, setPosts] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [selectedPost, setSelectedPost] = useState(null)
  const [followedAuthors, setFollowedAuthors] = useState({})

  const loadFeed = async () => {
    if (!user) return
    setIsLoading(true)
    try {
      const result = await feedService.getFeed()
      setPosts(result.map(mapPost))
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    if (!loading && !user) {
      navigate('/login')
      return
    }

    loadFeed()
  }, [user, loading])


  const toggleFollow = async (authorId) => {
    const isFollowed = followedAuthors[authorId]
    if (isFollowed) await followService.unfollow(authorId)
    else await followService.follow(authorId)
    setFollowedAuthors((prev) => ({ ...prev, [authorId]: !isFollowed }))
  }

  const handleLike = async (postId, isLiked) => {
    if (isLiked) await feedService.likePost(postId)
    else await feedService.unlikePost(postId)
    loadFeed()
  }

  if (isLoading) {
    return <FeedSkeleton />
  }

  return (
    <div className="min-h-screen bg-background pb-20">
      <FeedHeader sortMode="chronological" onSortChange={() => {}} />
      <main className="max-w-2xl mx-auto px-4 py-4 space-y-4">
        {posts.map((post) => (
          <div key={post.id} className="space-y-2">
            {post.userId !== user?.id && (
              <button
                onClick={() => toggleFollow(post.userId)}
                className="text-sm text-primary hover:underline"
              >
                {followedAuthors[post.userId] ? 'Unfollow' : `Follow @${post.username}`}
              </button>
            )}
            <PostCard
            post={post}
            onLike={handleLike}
            onComment={() => {}}
            onShare={() => {}}
            onOpenDetails={setSelectedPost}
          />
          </div>
        ))}
        {!posts.length && <p className="text-muted-foreground">No posts yet. Create one!</p>}
      </main>

      <PostDetailsOverlay post={selectedPost} isOpen={!!selectedPost} onClose={() => setSelectedPost(null)} />
      <BottomTabNavigation activeTab="home" />
    </div>
  )
}

export default HomeFeed
